import { faBuilding, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Container } from 'react-bootstrap';
import WorkExperienceIcon from '../../../../../assets/images/ic_experience_violet.png';
import { generateColors } from '../../../../../utils/colorUtilsClientInfo';
import './jobRoleDetails.css';
import { faCirclePause } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
const JobRoleDetails = ({ jobDetail, index, isCurrentRole }) => {
  const colours = generateColors(index);

  const [viewMore, setViewMore] = useState(false);
  if (jobDetail.isCareerGap === true) {
    return (
      <Container className="hoverHighlight career-gap-block">
        <Row className="d-flex justify-content-center p-1 mt-1 work-experience-container">
          <Col xs={2} sm={2} lg={1} className="d-flex justify-content-center">
            <span className="rounded-span" style={{ backgroundColor: colours.backgroundColor, color: colours.color }}>
              <FontAwesomeIcon icon={faCirclePause} />
            </span>
          </Col>
          <Col xs={8} sm={8} lg={9}>
            <Row>
              <Col xs={12}>
                <span className="jobTitle">Career Gap</span>
              </Col>
              <Col xs={12}>
                {jobDetail.startDate && (
                  <span className="jobSubTitle2">
                    {new Date(jobDetail.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                  </span>
                )}
                {(jobDetail.startDate || jobDetail.endDate) && (
                  <span className="jobSubTitle2"> to </span>
                )}
                {jobDetail.endDate ? (
                  <span className="jobSubTitle2">
                    {new Date(jobDetail.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                  </span>
                ) : (
                  <span className="jobSubTitle2">Ongoing</span>
                )}
              </Col>
            </Row>
          </Col>
          <Col xs={2} sm={2} lg={2} className="d-flex align-items-start justify-content-center">
            {jobDetail.reasons && (
              <a
                className="viewMore"
                onClick={(e) => {
                  e.preventDefault();
                  setViewMore(!viewMore);
                }}
              >
                <span className='viewMore'>
                  <span className="viewMoreText">{viewMore ? 'View Less' : 'View More'}</span>
                  <FontAwesomeIcon icon={viewMore ? faChevronUp : faChevronDown} className="viewMoreIcon" />
                </span>
              </a>
            )}
          </Col>
        </Row>
        {viewMore && jobDetail.reasons && (
          <Row className="p-1 mt-1 work-experience-container jobContent pt-2 d-flex justify-content-center align-items-center">
            <Col lg={1}>&nbsp;</Col>
            <Col lg={9} md={8} xs={8}>
              <Row>
                <Col xs={12}>
                  <h5 className="jobDetailsTitle">Reason for Gap</h5>
                  <p className="jobDetailsContent">{jobDetail.reasons}</p>
                </Col>
              </Row>
            </Col>
            <Col lg={2}>&nbsp;</Col>
          </Row>
        )}
      </Container>
    );
  }

  return (
    <Container className="hoverHighlight">
      <Row className="d-flex justify-content-center  p-1 mt-1 work-experience-container">
        <Col xs={2} sm={2} lg={1} className="d-flex justify-content-center">
          <span className="rounded-span" style={{ backgroundColor: colours.backgroundColor, color: colours.color }}>
            <img src={WorkExperienceIcon} alt="Work Experience Icon" />
          </span>
        </Col>

        <Col xs={8} sm={8} lg={9}>
          <Row>
            <Col xs={12}>
              <span className="jobTitle">{_.get(jobDetail, 'designation')}</span>{' '}
              <span className="jobSubTitle">
                {' at ' + _.get(jobDetail, 'orgName')}, {_.get(jobDetail, 'location')}
              </span>
            </Col>
            <Col xs={12}>
              {_.get(jobDetail, 'startDate') && (
                <span className="jobSubTitle2">
                  {new Date(jobDetail.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                </span>
              )}

              {_.get(jobDetail, 'startDate') && (
                <>
                  {isCurrentRole && (
                    <>
                      <span className="jobSubTitle2"> to </span>
                      <span className="jobSubTitle2">
                        {_.get(jobDetail, 'endDate')
                          ? new Date(jobDetail.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long' })
                          : 'Present'}
                      </span>
                    </>
                  )}

                  {!isCurrentRole && _.get(jobDetail, 'endDate') && (
                    <>
                      <span className="jobSubTitle2"> to </span>
                      <span className="jobSubTitle2">
                        {new Date(jobDetail.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                      </span>
                    </>
                  )}
                </>
              )}

              {/* {_.get(jobDetail, 'industry') && (
                <span className="jobSubTitle3">{' - ' + _.get(jobDetail, 'industry')}</span>
              )} */}
              {jobDetail.industry && (
                <span className="jobSubTitle3">
                  {' - '}
                  {jobDetail.industry}
                  {jobDetail.industrySubcategory &&
                    ` (${jobDetail.industrySubcategory})`}
                </span>
              )}
              <Col>
                {jobDetail.function && (
                  <span className="jobSubTitle3">
                    <FontAwesomeIcon icon={faBuilding} />{' '}
                    {jobDetail.function}
                    {jobDetail.functionSubcategory &&
                      ` (${jobDetail.functionSubcategory})`}
                  </span>
                )}
              </Col>


            </Col>
          </Row>

        </Col>

        <Col xs={2} sm={2} lg={2} className="d-flex align-items-start justify-content-center">
          {(
            _.get(jobDetail, 'topThreeResponsibilities') ||
            _.get(jobDetail, 'topThreeAchievements') ||
            (jobDetail.hasPromotions === 'YES' && jobDetail.promotions?.length > 0)
          ) && (
              <a
                className="viewMore"
                onClick={(e) => {
                  e.preventDefault();
                  setViewMore(!viewMore);
                }}
              >
                <span className='viewMore'>
                  <span className="viewMoreText">
                    {viewMore ? 'View Less' : 'View More'}
                  </span>
                  <FontAwesomeIcon
                    icon={viewMore ? faChevronUp : faChevronDown}
                    className="viewMoreIcon"
                  />
                </span>
              </a>
            )}

        </Col>
      </Row>

      {viewMore && (
        <Row className="p-1 mt-1 work-experience-container jobContent pt-2 d-flex justify-content-center align-items-center">
          <Col lg={1}>&nbsp;</Col>
          <Col lg={9} md={8} xs={8}>
            <Row>
              {_.get(jobDetail, 'topThreeResponsibilities') && (
                <Col lg={12}>
                  <h5 className="jobDetailsTitle">My Top 3 Responsibilities are</h5>
                  <p className="jobDetailsContent" style={{ whiteSpace: 'pre-line' }}>
                    {_.get(jobDetail, 'topThreeResponsibilities')}
                  </p>
                </Col>
              )}

              {_.get(jobDetail, 'topThreeAchievements') && (
                <Col lg={12} className="mt-3">
                  <h5 className="jobDetailsTitle">My Top 3 Achievements are</h5>
                  <p className="jobDetailsContent" style={{ whiteSpace: 'pre-line' }}>
                    {_.get(jobDetail, 'topThreeAchievements')}
                  </p>
                </Col>
              )}

              {jobDetail.hasPromotions === 'YES' && jobDetail.promotions?.length > 0 && (
                <Col lg={12} className="mt-3">
                  <h5 className="jobDetailsTitle">Promotions</h5>
                  <ul className="jobDetailsContent">
                    {jobDetail.promotions.map((promo, idx) => (
                      <li key={`promotion-${idx}`}>
                        Promoted from <strong>{promo.previousDesignation}</strong> in {promo.promotionYr}
                      </li>
                    ))}
                  </ul>
                </Col>
              )}
            </Row>
          </Col>
          <Col lg={2}>&nbsp;</Col>
        </Row>
      )}
    </Container>
  );
};

export default JobRoleDetails;
